import axios from "axios";
import { baseUrl } from "config";


const axiosInstance = axios.create({
  baseURL: baseUrl,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});


export default axiosInstance;